import { isSeatDetailsAvailable } from './seat-details-utils';
/**
 * Toggles the selection of a given seat and returns an updated array of selected seats.
 * Adheres to the provided seat selection limits and pops seats as necessary.
 * Returns `undefined` if no changes were made.
 */
export const toggleSeatSelection = (selectedSeats, seatSelectionLimits, toggledSeatDetails) => {
    const { seat, isSelected } = toggledSeatDetails;
    if (isSelected)
        return selectedSeats.filter(s => s.id !== seat.id);
    if (!isSeatDetailsAvailable(toggledSeatDetails))
        return undefined;
    const updatedSelectedSeats = [...selectedSeats, seat];
    const { areaCategoryId } = seat;
    const { limitsPerAreaCategory } = seatSelectionLimits;
    const areaCategoryLimit = limitsPerAreaCategory && limitsPerAreaCategory[areaCategoryId];
    if (areaCategoryLimit !== undefined) {
        const countForAreaCategory = getSelectedSeatCountForAreaCategory(updatedSelectedSeats, areaCategoryId);
        if (countForAreaCategory > areaCategoryLimit.max) {
            popFirstSelectedSeatForAreaCategory(updatedSelectedSeats, areaCategoryId);
        }
    }
    if (updatedSelectedSeats.length > seatSelectionLimits.max) {
        popFirstSelectedSeat(updatedSelectedSeats);
    }
    return updatedSelectedSeats;
};
const popFirstSelectedSeat = (selectedSeats) => {
    selectedSeats.shift();
};
const popFirstSelectedSeatForAreaCategory = (selectedSeats, areaCategoryId) => {
    const firstSeatIndexForAreaCategory = selectedSeats.findIndex(s => s.areaCategoryId === areaCategoryId);
    selectedSeats.splice(firstSeatIndexForAreaCategory, 1);
};
const getSelectedSeatCountForAreaCategory = (selectedSeats, areaCategoryId) => {
    return selectedSeats.filter(s => s.areaCategoryId === areaCategoryId).length;
};
